import React from "react";
import "./Footer.css";

import { useTranslation } from "react-i18next";

export default function Footer() {

  const { t } = useTranslation();

  return (
    <footer className="home-footer">
      <p className="footer-tagline">{t("footer.poweredBy")}</p>
      <hr></hr>
      {/* <p className='footer-warning-sign'>⚠️</p> */}
      <div className="footer-disclaimer">
        <strong style={{ fontSize: "16px" }}>⚠️</strong>
        {t("footer.disclaimer1")}
        <strong>{t("footer.disclaimer2")} </strong>
        {t("footer.disclaimer3")}
        {/* {t("footer.disclaimer4")} */}

        <p className="footer-important">
          {t("footer.disclaimer5")}
        </p>
      </div>
    </footer>
  );
}
